export default "__VITE_ASSET__CBcuySBL__"